var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.511,
    height: 206.099,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.793 203.037a2.734 2.734 0 0 0-2.255-2.308l-11.972-1.02c-6.335-1.664-11.005-8.7-11.972-15.193l-.644-4.134H95.56l-.644 4.08c-1.02 6.5-5.637 13.529-11.972 15.193l-11.972 1.02a2.929 2.929 0 0 0-2.255 2.308 2.754 2.754 0 0 0 2.738 3.114h97.6a2.712 2.712 0 0 0 2.738-3.06zM236.7 3.758A12.968 12.968 0 0 0 227.572 0H12.992a12.875 12.875 0 0 0-9.126 3.758A13.075 13.075 0 0 0 0 12.884v146.024a12.978 12.978 0 0 0 3.865 9.126 12.719 12.719 0 0 0 9.019 3.758h214.741a12.627 12.627 0 0 0 9.019-3.758 13.075 13.075 0 0 0 3.865-9.126V12.884a12.8 12.8 0 0 0-3.809-9.126zm-116.445 155.15a4.295 4.295 0 1 1 4.295-4.295 4.307 4.307 0 0 1-4.295 4.295zm109.464-21.474H10.844a2.154 2.154 0 0 1-2.147-2.147V15.032a6.461 6.461 0 0 1 6.442-6.442h210.285a6.461 6.461 0 0 1 6.442 6.442v120.255a2.154 2.154 0 0 1-2.147 2.147z",
    fill: "#0b72b9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/websiteIcon.549318f52968d52bca0cfae21b3262be.svg";
export { ForwardRef as ReactComponent };